// @ts-nocheck

import React, { useEffect } from 'react';
import styled, { keyframes, css } from 'styled-components';

import * as LoaderAssets from '../../assets/svg/loader';
import theme from '../../styled-components/dark';

const SIZE = 7.5;

const ANIMATION_DURATION = 1500;

const haloAnimation = keyframes`
  0% {
    box-shadow: none;
  }

  50% {
    box-shadow: 0em 0em 0.4em 0.1em #b20e1087;
  }

  100% {
    box-shadow: none;
  }
`;

const translationBefore = keyframes`
  0% {
    transform: translateY(${SIZE}em);
  }

  100% {
    transform: translateY(-${SIZE}em);
  }
`;

const svgStyle = css`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  height: 50%;
  width: 50%;
`;

const Wrapper = styled.div`
  width: 100%;
  margin: 10vh 0;

  display: flex;
  justify-content: center;
  align-items: center;

  ${({ $hidden }) => ($hidden ? 'opacity: 0;' : 'opacity: 1;')}
  transition: opacity 0.5s ease-in-out;
`;

const Border = styled.div`
  width: ${SIZE}em;
  height: ${SIZE}em;
  margin: 0;
  padding: 0;

  background: transparent;
  border: 0.1em solid ${theme.WinaLoader.outerBorderColor};
  border-radius: 50%;
  box-shadow: none;

  animation: ${haloAnimation} 3000ms ease-in-out infinite;

  z-index: 3;
`;

const StyledLoaderBorderSvg = styled(LoaderAssets.WinamaxLoaderBorder)`
  z-index: 4;
  ${svgStyle};
`;

const StyledLoaderFullSvg = styled(LoaderAssets.WinamaxLoaderFull)`
  z-index: 1;
  ${svgStyle}
`;

const Content = styled.div`
  position: relative;
  height: 100%;
  width: 100%;

  background: black;
  border-radius: 50%;

  overflow: hidden;

  display: flex;
  justify-content: center;
  align-items: center;

  background: ${theme.WinaLoader.backgroundColor};
  box-shadow: 0em 0em 1em 0.05em rgba(18, 18, 18, 0.75);
  border: 0.1em solid ${theme.WinaLoader.innerBorderColor};

  transform: translate3d(0, 0, 0);

  &:before {
    content: '';
    position: absolute;
    top: 0%;
    left: 0%;
    width: 100%;
    height: 100%;
    background: ${theme.WinaLoader.backgroundColor};

    animation: ${translationBefore} ${ANIMATION_DURATION}ms cubic-bezier(0.25, 0.46, 0.21, 0.86) infinite;

    z-index: 2;
  }
`;

type PropsType = {
  className?: string;
  delayed?: boolean;
};

const WinaLoader = ({ className, delayed }: PropsType) => {
  const [readyToShow, setReadyToShow] = React.useState(!delayed);

  useEffect(() => {
    if (delayed) {
      const timeout = setTimeout(() => {
        setReadyToShow(true);
      }, 400);
      return () => clearTimeout(timeout);
    }
  }, [delayed]);

  return (
    <Wrapper className={className} data-testid="winaloader" $hidden={!readyToShow}>
      <Border>
        <Content>
          <StyledLoaderFullSvg title="fullLoader" />
          <StyledLoaderBorderSvg title="borderLoader" />
        </Content>
      </Border>
    </Wrapper>
  );
};

export default WinaLoader;
